import { Notification, NotificationColl } from 'src/dto'
import ExtendedMap from 'src/models/ExtendedMap'

import notificationApi from '@/api/notification.api'

export const notificationController = {
  fetchItems: async (props: req.Notification) => {
    const {
      data: { result, hasBefore },
    } = await notificationApi.fetchNotifications(props)
    const notificationArr = result.map((notifi) => new Notification(notifi)) as Notification[]

    return {
      hasBefore,
      notificationColl: new NotificationColl(ExtendedMap.fromArr(notificationArr, 'sortKey')),
    }
  },
  fetchUnreadCount: async (props: req.NotificationPartitionKey) => {
    const { data } = await notificationApi.fetchUnreadCount(props)

    return data
  },
  readItem: (props: req.ReadNotification) => {
    notificationApi.readNotification(props)
  },
  deleteCTA: (props: req.DeleteNotificationCTA) => {
    notificationApi.deleteCTA(props)
  },
}
